import React from 'react'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import App from 'App'
import Home from 'pages/Home'
import QuestionList from 'pages/QuestionList'
import Practice from 'pages/Practice'
import Report from 'pages/Report'
import Answer from 'pages/Answer'
import config from 'config.json'

function jumpMainPage () {
  window.location = `${config.site.zhike}/toefl/exercise.html`
}

function jumpMobilePage(nextState){
  let u = navigator.userAgent;
  let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  let isMobile = Agents.some(a => u.indexOf(a) > 0);
  if (isMobile){
    let redirctUrl = `${config.site.zhike}/${nextState.params.exam}/phone-lead.html`
    window.location.href = redirctUrl;
  }
}

function changeRouteLog(prevState, nextState){
  if (prevState.location.pathname !== nextState.location.pathname ||
      prevState.location.search !== nextState.location.search) {
    // 神策统计 - 首次加载不执行
    typeof sa !== 'undefined' && sa.quick('autoTrackSinglePage'); // eslint-disable-line
  }
};

export default (
  <Router history={ browserHistory }>
    <Route path="/healthCheck" component={() => <h3>健康检查</h3>} />
    <Route path="/:exam" component={ App } onChange={changeRouteLog} >
      <IndexRoute component={ Home } />
      <Route path="practice/:pid/question/:qid" component={ Practice } onEnter={jumpMobilePage}/>
      <Route path="answer" component={ Answer } onEnter={jumpMobilePage}/>
    </Route>
    <Route path="*" onEnter={ jumpMainPage } />
  </Router>
)



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/